const Rails = require('@rails/ujs')
import bootbox from 'bootbox';

// Overrides default rails confirmation with bootstrap 4 confirm dialog
Rails.confirm = function(message, element) {
  bootbox.confirm(message, function(result){
    if (result) {
      let old = Rails.confirm
      Rails.confirm = function() { return true }
      $(element).get(0).click()
      Rails.confirm = old
    }
  })
  return false;
}